import t from"./_assocIndexOf.js";function a(a){var o=this.__data__,r=t(o,a);return r<0?void 0:o[r][1]}export{a as default};
//# sourceMappingURL=_listCacheGet.js.map
